import React from "react";
import styled from "styled-components";

import Footer from "../components/Footer";
import Topbar from "../components/Topbar";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
`;

const PrivacyPolicy = () => {
  return (
    <Container>
      <Topbar />
      <Content>
        <section className="legal-page">
          <div className="container legal-page-container">
            <div className="legal-page-header">
              <p className="section-label">Privacy Policy</p>
              <h1>How True-Extract Handles Personal Data</h1>
              <p className="legal-updated">Last updated: 1 June 2026</p>
            </div>

            <div className="legal-page-content">
              <section>
                <h2>Who We Are</h2>
                <p>
                  True-Extract is a mobile forensics and digital investigation services provider operated by DATA IN LTD. Our registered office is 124 City Road, London, EC1V 2NX. You can contact us about this policy or your personal data at <a href="mailto:info@true-extract.co.uk">info@true-extract.co.uk</a>.
                </p>
              </section>

              <section>
                <h2>Information We Collect</h2>
                <p>
                  We collect information you provide when you contact us, request services, upload files, register for access, or use download links. This may include your name, email address, phone number, organisation, case reference details, messages, uploaded files, download activity, and technical information such as IP address, browser details, timestamps, and security logs.
                </p>
                <p>
                  Because our services involve mobile forensics, case material may contain personal data or sensitive information relating to you or other people. We ask clients to provide only the information needed for the requested service.
                </p>
              </section>

              <section>
                <h2>How We Use Information</h2>
                <p>We use personal data to:</p>
                <ul>
                  <li>respond to enquiries and provide quotations;</li>
                  <li>deliver mobile forensics, extraction, analysis, reporting, upload, and download services;</li>
                  <li>verify access, send one-time PINs, and protect case materials;</li>
                  <li>manage client relationships, records, invoices, and support requests;</li>
                  <li>maintain service security, audit logs, backups, and fraud prevention controls;</li>
                  <li>comply with legal, regulatory, court, law enforcement, or professional obligations.</li>
                </ul>
              </section>

              <section>
                <h2>Lawful Bases</h2>
                <p>
                  We process personal data where it is necessary to perform a contract with you or take steps before entering a contract, where we have a legitimate interest in operating and protecting our services, where we must comply with legal obligations, or where you have given consent for a specific purpose.
                </p>
                <p>
                  Where special category data or criminal offence data is involved in case material, we process it only where an appropriate legal condition applies, such as legal claims, substantial public interest, explicit consent, or another lawful basis relevant to the instruction.
                </p>
              </section>

              <section>
                <h2>Sharing Information</h2>
                <p>
                  We do not sell personal data. We may share information with trusted service providers who help us host, secure, store, transfer, analyse, or communicate about our services. We may also share information with professional advisers, insurers, regulators, courts, law enforcement, or other parties where required by law or by the scope of the service you request.
                </p>
              </section>

              <section>
                <h2>International Transfers</h2>
                <p>
                  Where personal data is transferred outside the United Kingdom, we use appropriate safeguards such as adequacy regulations, approved contractual clauses, or other lawful transfer mechanisms.
                </p>
              </section>

              <section>
                <h2>How Long We Keep Information</h2>
                <p>
                  We keep personal data only for as long as needed for the purpose it was collected, including service delivery, case management, security, legal, accounting, and dispute resolution requirements. Case files and forensic materials are retained according to the agreed service terms, client instructions, or applicable legal obligations.
                </p>
              </section>

              <section>
                <h2>Security</h2>
                <p>
                  We use technical and organisational measures designed to protect personal data against unauthorised access, loss, misuse, alteration, or disclosure. These measures may include access controls, encryption in transit, secure upload and download links, one-time PIN verification, logging, and restricted staff access.
                </p>
              </section>

              <section>
                <h2>Your Rights</h2>
                <p>
                  Depending on the circumstances, you may have rights to access, correct, erase, restrict, object to, or receive a copy of your personal data. You may also have the right to withdraw consent where consent is our lawful basis. To exercise your rights, contact us at <a href="mailto:info@true-extract.co.uk">info@true-extract.co.uk</a>.
                </p>
              </section>

              <section>
                <h2>Complaints</h2>
                <p>
                  We would appreciate the chance to address any privacy concern first. You also have the right to complain to the Information Commissioner's Office, the UK supervisory authority for data protection. You can visit the ICO at <a href="https://ico.org.uk/" target="_blank" rel="noreferrer">ico.org.uk</a>.
                </p>
              </section>

              <section>
                <h2>Changes To This Policy</h2>
                <p>
                  We may update this policy from time to time. When we make material changes, we will update the date above and, where appropriate, provide additional notice.
                </p>
              </section>
            </div>
          </div>
        </section>
      </Content>
      <Footer />
    </Container>
  );
};

export default PrivacyPolicy;
